import { FadeUp } from "./Motion";
import { ShieldCheck, KeyRound, FileCheck2 } from "lucide-react";

const items = [
  {
    icon: KeyRound,
    title: "Consent-first",
    body: "Every data point — bank statements, UPI, GST, invoices — is shared with the business owner&apos;s explicit consent.",
  },
  {
    icon: FileCheck2,
    title: "Purpose-bound",
    body: "Data is used only to generate the Business Health Report. It is not resold, syndicated, or repurposed.",
  },
  {
    icon: ShieldCheck,
    title: "Auditable",
    body: "Every signal in the report traces back to a verifiable source — designed for lender due-diligence review.",
  },
];

export const Trust = () => {
  return (
    <section
      id="trust"
      className="relative py-20 md:py-28 border-t border-ink/10 bg-white"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <FadeUp>
          <div className="flex items-center gap-6 mb-12">
            <span className="font-mono-cap text-ink/60">Note — Built on Consent</span>
            <span className="hair-divider flex-1" />
          </div>
        </FadeUp>

        <div className="grid grid-cols-12 gap-6 md:gap-10 items-start">
          <div className="col-span-12 lg:col-span-5">
            <FadeUp>
              <h3 className="font-display text-4xl md:text-5xl text-ink leading-[1] tracking-tight">
                How we <br />
                <span className="italic text-teal">handle data</span>.
              </h3>
            </FadeUp>
          </div>
          <div className="col-span-12 lg:col-span-7 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {items.map((it, i) => {
              const Icon = it.icon;
              return (
                <FadeUp key={it.title} delay={i * 0.08}>
                  <div className="border-t border-ink/20 pt-5">
                    <div className="w-9 h-9 flex items-center justify-center bg-ink text-paper">
                      <Icon size={16} strokeWidth={1.5} />
                    </div>
                    <div className="font-display text-xl md:text-2xl text-ink mt-5">
                      {it.title}
                    </div>
                    <p
                      className="font-sans text-sm text-ink/70 mt-3 leading-relaxed"
                      dangerouslySetInnerHTML={{ __html: it.body }}
                    />
                  </div>
                </FadeUp>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
